import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderApprovalDetailsTotalStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderApprovalDetailsTotalStyles.cartTotal = mergeToNew(orderApprovalDetailsTotalStyles.cartTotal, {
    container: {
        css: css`
            background-color: ${getColor("secondary")};
            padding: 15px;
        `,
    },
    totalLabel: {
        color: "text.accent",
    },
    totalValue: {
        color: "text.accent",
    },
});
